import { createAction, props } from "@ngrx/store";
import { EnvironmentStatus } from "../models/environment-status";

export const EnvironmentStatusActions = {
    get: createAction("[EnvironmentStatus] Get"),
    set: createAction("[EnvironmentStatus] Set", props<{ status: EnvironmentStatus | null }>()),
};
